import {
  RESCUE_MODAL_UI_BUTTON_SUBTEXT_DEFAULT,
  RescueModalUiButtonSubtext,
} from "@redotech/redo-conversion-settings-common/predictive-conversion-settings";
import { assertNever } from "@redotech/util/type";

export function rescuePanelButtonSubtext(
  subtext: RescueModalUiButtonSubtext,
  coverageEligible: boolean,
): string | undefined {
  switch (subtext.shouldShow) {
    case "always":
      return subtext.value;
    case "if_coverage_eligible":
      return coverageEligible
        ? subtext.value || RESCUE_MODAL_UI_BUTTON_SUBTEXT_DEFAULT.value
        : undefined;
    case "never":
      return undefined;
    default:
      assertNever(subtext);
  }
}
